export let StoreState = /*#__PURE__*/function (StoreState) {
  StoreState[StoreState["INACTIVE"] = 0] = "INACTIVE";
  StoreState[StoreState["ACTIVE"] = 1] = "ACTIVE";
  return StoreState;
}({});
export let StoreType = /*#__PURE__*/function (StoreType) {
  StoreType[StoreType["STANDARD"] = 1] = "STANDARD";
  StoreType[StoreType["SILVER_ONLY"] = 2] = "SILVER_ONLY";
  return StoreType;
}({});

/** Số điện thoại mặc định khi store không có hotline (dùng trong checkout PICKUP) */
export const DEFAULT_STORE_HOTLINE = '0902972972';
export const REGIONS = {
  hcm: 'TP. Hồ Chí Minh',
  hanoi: 'Hà Nội',
  quangninh: 'Quảng Ninh'
};
export const STATE_OPTIONS = [{
  label: 'Hoạt động',
  value: StoreState.ACTIVE
}, {
  label: 'Không hoạt động',
  value: StoreState.INACTIVE
}];
export const TYPE_OPTIONS = [{
  label: 'Tiêu chuẩn',
  value: StoreType.STANDARD
}, {
  label: 'Chuyên Bạc (Silver Only)',
  value: StoreType.SILVER_ONLY
}];
export const REGION_OPTIONS = [{
  label: 'TP. Hồ Chí Minh',
  value: 'hcm'
}, {
  label: 'Hà Nội',
  value: 'hanoi'
}, {
  label: 'Quảng Ninh',
  value: 'quangninh'
}];
//# sourceMappingURL=store.constant.js.map